module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column",
    attrs: {
      "id": "selecao-de-projeto-de-subsidio"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formulario"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media u-margem-esquerda-pequena"
  }, [_vm._v("\n            Selecione o projeto para efetuar o cadastro\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }],
    attrs: {
      "id": "projeto",
      "name": "projeto"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.redirecionar]
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto
      }
    }, [_vm._v("\n                      " + _vm._s(projeto.Nome) + "\n                  ")])
  }), 0)])])])], 1), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715517fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selecao-de-projeto-de-subsidio/SelecaoDeProjetoDeSubsidio.vue
// module id = 1125
// module chunks = 1